import { useSelector } from "react-redux";

export default function useScopedCurrency() {
  return useSelector(state => state.scopedCurrency);
}
